import { ArrowDown } from "lucide-react";
import { BRAND, IMAGES } from "../../lib/data";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-screen min-h-[680px] w-full overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Plage de Palavas-les-Flots"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-zp-navy/40 via-zp-navy/15 to-zp-navy/55" />
      </div>

      {/* Decorative striped border at top */}
      <div className="absolute top-0 left-0 right-0 h-2 cabana-stripes-blue z-10 opacity-90" />

      {/* Content */}
      <div className="relative z-10 h-full flex items-end pb-20 md:pb-28">
        <div className="mx-auto max-w-[1400px] w-full px-6 md:px-12 lg:px-16">
          <div className="max-w-3xl">
            <p
              data-testid="hero-eyebrow"
              className="overline text-zp-lemon mb-6 flex items-center gap-3"
            >
              <span className="dot" /> Palavas-les-Flots · depuis 1996
            </p>
            <h1
              data-testid="hero-title"
              className="font-serif text-white text-[3.4rem] sm:text-7xl lg:text-[7.5rem] leading-[0.95] tracking-tight font-medium"
            >
              Le soleil, <br />
              <span className="italic font-light">à son zénith.</span>
            </h1>
            <p
              data-testid="hero-subtitle"
              className="text-white/90 text-lg md:text-xl font-light max-w-xl mt-8 leading-relaxed"
            >
              Plage privée, restaurant et bar les pieds dans le sable.
              Une parenthèse familiale et authentique sur la côte
              méditerranéenne.
            </p>

            <div className="flex flex-wrap items-center gap-4 mt-10">
              <a
                href="#carte"
                data-testid="hero-cta-menu"
                className="btn-accent"
              >
                Voir la carte
              </a>
              <a
                href="#contact"
                data-testid="hero-cta-reserve"
                className="btn-ghost"
              >
                Nous contacter
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#apropos"
        data-testid="hero-scroll"
        className="absolute bottom-8 right-6 md:right-12 z-10 text-white/80 hover:text-zp-lemon flex flex-col items-center gap-3 transition-colors"
      >
        <span className="overline text-[10px]">Découvrir</span>
        <ArrowDown size={18} className="animate-bounce" />
      </a>

      {/* Brand corner marker */}
      <div className="absolute top-28 right-6 md:right-12 z-10 hidden md:flex flex-col items-end gap-1">
        <div className="overline text-[10px] text-white/70">Ouvert</div>
        <div className="font-serif italic text-white text-2xl">{BRAND.hours.split('·')[1].trim()}</div>
      </div>
    </section>
  );
};

export default Hero;
